import Vue from 'vue'
import { firebaseTools } from '../utils/firebase'

// initial state
const state = {
  account: {},
  roles: {},
  invitations: null,
  isAdmin: false,
  isObserver: false,
  isAccess: false,
  showSidebar: false,
  phoneNumber: null,
  email: null,
  uid: null,
  jwt: null,
  disconnected: false,
  phoneDetails: null,
  instancesInfo: {},
  tempPhone: null,
  hasEmailProvider: false,
  isRecovering: false,
}

// getters
const getters = {}

// actions
const actions = {
  getJWT ({ commit }) {
    firebaseTools.getCurrentUserJWT(true)
      .then(jwt => {
        commit('setJWT', jwt)
      })
      .catch(err => { console.error(err) })
  },
}

// mutations
const mutations = {
  setTempPhone (state, phone) {
    state.tempPhone = phone
  },
  setIsRecovering (state, status) {
    state.isRecovering = status
  },
  setPhoneDetails (state, phoneDetails) {
    state.phoneDetails = phoneDetails
  },
  setAccount (state, account) {
    if (account.support || (typeof account.administrator !== 'undefined' && account.administrator.length > 0)) {
      state.isAdmin = true
      state.roles.isAdmin = true
      state.showSidebar = typeof account.creationStep === 'undefined'
    }
    if (typeof account.observer !== 'undefined' && account.observer.length > 0) {
      state.isObserver = true
      state.roles.isObserver = true
      state.showSidebar = typeof account.creationStep === 'undefined'
    }
    if (typeof account.accessibleInstances !== 'undefined' && account.accessibleInstances.length > 0) {
      state.roles.isAccess = true
      state.isAccess = true
    }
    state.account = account
  },
  checkRoles (state, account) {
    if (account.support || (typeof account.administrator !== 'undefined' && account.administrator.length > 0)) {
      state.isAdmin = true
      state.roles.isAdmin = true
      state.showSidebar = typeof account.creationStep === 'undefined'
    }
    if (typeof account.observer !== 'undefined' && account.observer.length > 0) {
      state.isObserver = true
      state.roles.isObserver = true
      state.showSidebar = typeof account.creationStep === 'undefined'
    }
    if (typeof account.accessibleInstances !== 'undefined' && account.accessibleInstances.length > 0) {
      state.isAccess = true
      state.roles.isAccess = true
    }
  },
  setAccountDisconnected (state) {
    state.disconnected = true
  },
  setInstancesInfo (state, obj) {
    Vue.set(state.instancesInfo, obj.instanceID, { ...obj.data, instanceID: obj.instanceID })
  },
  setUser (state, user) {
    state.hasEmailProvider = !!user.providerData.find(provider => provider.providerId === 'password')
    state.uid = user.uid
    state.phoneNumber = user.phoneNumber
    state.email = user.email || null
  },
  cleanUID (state) {
    state.uid = false
  },
  setInvitations (state, invitations) {
    state.invitations = invitations
  },
  setJWT (state, jwt) {
    state.jwt = jwt
  },
  setProp (state, obj) {
    state[obj.prop] = obj.val
  },
  deleteObjectKey (state, obj) {
    delete state[obj.prop][obj.key]
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
